// import { useEffect } from 'react'
import { Container } from 'react-bootstrap'
// import { useLocation } from 'react-router-dom'

const PrivacyPolicy = () => {
	// const { pathname } = useLocation()
  
	// useEffect(() => {
	//   window.scrollTo(0, 0)
	// }, [pathname])
	return (
		<Container>
			<br />
			<div className='text-center'>
				<h1>Findjobs Privacy Policy</h1>
				<p>Last modified : 2 July 2020</p>
			</div>
			<br />
			<p>This Privacy Policy explains how Findjobs Pte Ltd (“Findjobs”, “we”, “us”, “our”) collects, uses and discloses data, including Personal Data, received in the course of your usage of the Findjobs website, mobile application, mobile kiosk and services (collectively “Platform”).</p>
			<h2>Personal Data</h2>
			<ol>
				<li>&quot;Personal Data&quot; is any data of an individual, whether true or not, which identifies an individual from that data or from that data and other information to which we have or are likely to have access.</li>
				<li>
          In the course of using our Platform, Personal Data that we collect of you may include:
					<ul>
						<li>Name, gender, contact details, address, photo, identification documents and details, passport;</li>
						<li>Employment history, educational background, salary details, bank details, credit history;</li>
						<li>Family details, criminal records, health records;</li>
						<li>Application forms and the details within;</li>
						<li>Usage patterns and interaction on Platform, cookies, IP address, computer and connectivity details, browser type and information; and</li>
						<li>Other relevant data that is necessary to facilitate your job application or job posting, as the case may be.</li>
					</ul>
				</li>
				<li>Findjobs is a jobs platform for job applicants and job posters and works with government agencies and MNCs. The Platform also displays available training courses from third-party providers and Findjobs assists with your registration of your chosen course. Therefore, it is necessary for Findjobs to obtain your fullest particulars, including your Personal Data, in order to adequately provide our services.</li>
			</ol>
			<h2>Collection</h2>
			<p>4. Findjobs collects your Personal Data in the following ways:</p>
			<ul>
				<li>using the Platform and any of our services;</li>
				<li>user account creation, maintenance and updating;</li>
				<li>submission of resume/curriculum vitae, professional references and forms;</li>
				<li>submission of application forms;</li>
				<li>interaction with our personnel via phone, email, contact forms or in-person;</li>
				<li>when you respond to our promotions, initiatives, marketing mailers or are contacting by our marketing personnel;</li>
				<li>when you request to be included in a mailing list;</li>
				<li>when you submit your Personal Data to us for any other reason.</li>
			</ul>
			<p>5. It is your duty to ensure that all Personal Data submitted to us are complete, accurate, true and correct.</p>
			<p>6. If you provide us with any Personal Data relating to a third-party (e.g. information of spouse, children, parents, employees and/or authorised representatives), by submitting such information to us, you represent to us that you have obtained the consent of the third-party to you providing us with their Personal Data for the respective purposes.</p>
			<h2>Use</h2>
			<p>7. Findjobs may process and use your Personal Data for the following purposes:</p>

			<p>For all users</p>
			<ul>
				<li>providing the Platform and its related services;</li>
				<li>to maintain your user account with us;</li>
				<li>responding to your queries, requests and complaints;</li>
				<li>compliance with applicable laws and regulations;</li>
				<li>audits, reviews, analysis of processes and risk management;</li>
				<li>verifying your data, information, personal particulars;</li>
				<li>provide you with services, including marketing services, which you had signed up or requested for;</li>
				<li>conducting of market and analytical research, understanding and determining customer location, preferences and demographics for us to review, develop and improve our products, services and also develop special offers and marketing programmes;</li>
				<li>sending you details of products, services, contests, special offers and rewards, provided by us or our affiliates, which may be of interest to you;</li>
				<li>From time-to-time sending to you job and skill opportunities, events and other related marketing messages via SMS or WhatsApp;</li>
				<li>submission to government partners to assist with providing you services; and</li>
				<li>any other purpose relating to the Platform, our services and any of the above.</li>
			</ul>
			<p>If user whom is a job applicant</p>
			<ul>
				<li>assisting or submitting your resume/curriculum vitae;</li>
				<li>background checks and due diligence checks;</li>
				<li>collecting information about your suitability for the position applied for;</li>
				<li>organising training and development programs;</li>
				<li>assessing your performance;</li>
				<li>sending you updates and alerts related to job applications which you may have requested for;</li>
				<li>submission to government partners as part of the job application procedure; and</li>
				<li>any other purpose relating to the Platform, our services to you as a job applicant and any of the above.</li>
			</ul>
			<p>If user whom is a job poster</p>
			<ul>
				<li>verifying your entity details;</li>
				<li>verifying the veracity of your job posts;</li>
				<li>organising training and development programs;</li>
				<li>assessing suitable services for you; and</li>
				<li>any other purpose relating to the Platform, our services to you as a job poster and any of the above.</li>
			</ul>
			<p>If user whom is applying for a training course</p>
			<ul>
				<li>verifying your application details;</li>
				<li>sending you suitable marketing information in relation to training courses;</li>
				<li>processing your application form and thereafter forwarding to the training course providers; and</li>
				<li>any other purpose relating to the Platform, our services to you as a training course applicant and any of the above.</li>
			</ul>

			<p>If user whom is posting or updating training course information</p>
			<ul>
				<li>verifying your entity details;</li>
				<li>verifying the veracity of your training courses;</li>
				<li>assessing suitable services for you; and</li>
				<li>any other purpose relating to the Platform, our services to you as a training course provider and any of the above.</li>
			</ul>
			<h2>Disclosure</h2>
			<p>8. Findjobs will only disclose your Personal Data for legitimate purposes as listed above, to:</p>
			<ul>
				<li>our affiliates, business partners, agents, contractor, vendor and third-party providers;</li>
				<li>government agencies;</li>
				<li>financial institutions, credit bureau and scoring agencies;</li>
				<li>professional advisors such as lawyers, auditors and accountants; and</li>
				<li>any other parties to whom you authorise us to disclose or is reasonably necessary for us to disclose.</li>
			</ul>
			<p>9. Where your Personal Data is transferred to an overseas jurisdiction, Findjobs will take steps to ensure that the recipient of your Personal Data is bound by legal obligations that is at minimum comparable to the Personal Data Protection Act 2012.</p>
			<h2>Updating of Personal Data & Withdrawal of Consent</h2>
			<p>10. You may contact our Data Protection Officer at ask@findjobs.com.sg to update, obtain a copy, delete or withdraw consent to use your Personal Data. A reasonable fee will be charged for such administrative processing.</p>
			<p>11. If your Personal Data has been provided to third-parties in the course of using our Platform or using our services in anyway, you must contact such third-party directly to withdraw consent or update your Personal Data. Accordingly, you acknowledge that Findjobs does not have control over such third-parties, and such third-parties may still contact you for, amongst others, marketing, search and recruitment and job matching services.</p>
			<p>12. If you withdraw your consent to the use of your Personal Data in any way, Findjobs will not be able to continue providing our services. If this results in a subsequent breach of contractual obligations, Findjobs expressly reserves its rights at law.</p>
			<h2>Third-Party Sites</h2>
			<p>13. The Platform may contain links to other third-party owned sites and platforms. These third-party sites and platforms may be co-branded with or display our logo or trademark. We are not responsible for such sites and platforms operated by such third-parties and you should check the applicable terms of use and privacy policies of the third-party site and platforms.</p>
			<h2>Cookie Policy</h2>
			<p>14. Findjobs deploys cookies which are small data files sent to your browser to store and track statistical and information about you when you use our Platform. These may include:</p>
			<ul>
				<li>Faster loading of the Platform;</li>
				<li>Browser type;</li>
				<li>Common entry, common exit and drop-off point;</li>
				<li>User profile; frequency of visit, time spent on pages and page views; and</li>
				<li>Organic traffic, paid traffic and unique visitors.</li>
			</ul>
			<p>15. Disabling of cookies is your personal choice by changing the setting on your browser. However, the Platform may no longer function as intended after disabling of cookies.</p>
			<h2>Governing Law</h2>
			<p>16. This Privacy Policy shall be governed exclusively by the laws of Singapore.</p>
			<br />
		</Container>
	)
}

export default PrivacyPolicy
